import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useBuilderHistory } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export const UndoRedoButtons = () => {
  const { canUndo, canRedo, undo, redo } = useBuilderHistory(state => ({
    canUndo: state.pastStates.length > 0,
    canRedo: state.futureStates.length > 0,
    undo: state.undo,
    redo: state.redo,
  }));

  return (
    <div className="flex items-center space-x-1">
      <IconButton
        className={classNames("cursor-pointer", {
          "cursor-not-allowed opacity-50": !canUndo,
        })}
        onClick={canUndo ? undo : noop}
        iconSize={20}
        buttonSize={28}
        disabled={!canUndo}
        name="20-undo"
        title={t("settings.site.pages.builder.undo")}
        ariaLabel={t("settings.site.pages.builder.undo")}
      />
      <IconButton
        className={classNames("cursor-pointer", {
          "cursor-not-allowed opacity-50": !canRedo,
        })}
        onClick={canRedo ? redo : noop}
        iconSize={20}
        buttonSize={28}
        disabled={!canRedo}
        name="20-redo"
        title={t("settings.site.pages.builder.redo")}
        ariaLabel={t("settings.site.pages.builder.redo")}
      />
    </div>
  );
};
